import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { connect } from 'redaction'
import actions from 'redux/actions'
import injectGlobals from 'decorators/injectGlobals'
import { compose, constants, snowplow } from 'common/helpers'

import Modal from 'components/modal/Modal/Modal'
import Title from 'components/_new/typography/deprecated/Title/Title'
import Box from 'components/_new/layout/Box/Box'
import FeedbackForm from 'pages/CancelSubscriptionPage/FeedbackForm/FeedbackForm'

import messages from './messages'
import s from './FeedbackModal.scss'


class FeedbackModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.shape({
      reasonName: PropTypes.string,
    }).isRequired,
  }

  static defaultProps = {
    name: constants.modals.cancelSubscription.Feedback,
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  trackCloseModal = (action) => {
    snowplow.track(constants.snowplowEvents.cancelSubscriptionStepComplete, {
      stepName: 'feedback modal',
      action,
    }, false)
  }

  handleCloseModal = () => {
    this.trackCloseModal('close')
  }

  handleSuccess = ({ isUnsubscribeSelected }) => {
    this.close()

    if (!isUnsubscribeSelected) {
      const date = moment()
        .add(1, 'days')
        .format('MMMM Do')

      const text = { ...messages.successMessage, values: { date } }

      actions.models.ui.showRequestLoader()
      actions.models.subscription.applyCoupon('NO_CHARGE')
        .then(
          () => actions.models.modals.open(constants.modals.humble.FeedbackFormSuccess, { text }),
          () => {}
        )
        .finally(() => {
          actions.models.ui.hideRequestLoader()
        })
    }
    else {
      const { data: { reasonName: reason }, isProlongOfferVisible } = this.props

      const unsubscribeData = {
        reason,
      }

      if (isProlongOfferVisible) {
        actions.models.modals.open(constants.modals.cancelSubscription.ProlongOffer, unsubscribeData)
        this.close()
      }
      else {
        actions.models.subscription.unsubscribe(unsubscribeData)
          .then(({ isRefundAvailable, refund }) => {
            if (isRefundAvailable || refund) {
              actions.models.modals.open(constants.modals.cancelSubscription.Refund, refund)
            }
            else {
              actions.models.modals.open(constants.modals.cancelSubscription.SubscriptionWasCancelled)
            }

            this.close()
          })
      }
    }
  }

  render() {
    const { name, data: { reasonName } } = this.props

    return (
      <Modal
        name={name}
        className={s.modal}
        onClose={this.handleCloseModal}
      >
        <Box alignLeft>
          <Title message={messages.title} size="md" />
          <Box mt="36">
            <FeedbackForm
              unsubscribeReason={reasonName}
              showSuccessModal={false}
              messageRows={10}
              withFreeMonthText
              onSuccess={this.handleSuccess}
            />
          </Box>
        </Box>
      </Modal>
    )
  }
}


export default compose(
  injectGlobals(({ getFeatureToggle }) => ({
    isUnsubscribeProlongedEnabled: getFeatureToggle(constants.features.unsubscribeProlonged),
  })),
  connect({
    isProlongOfferVisible: (state, props) => {
      const {
        models: {
          subscription: { currPlan: { billingPeriod }, isPaused, isUnpaused, isMonthlyPlan },
          ui: { closedPopups },
        },
      } = state
      const { isUnsubscribeProlongedEnabled } = props

      const isMonthlyPay   = billingPeriod === 1
      const wasModalClosed = closedPopups.prolongOfferModal

      return (
        isUnsubscribeProlongedEnabled
        && isMonthlyPlan
        && isMonthlyPay
        && !wasModalClosed
        && !isPaused
        && !isUnpaused
      )
    },
  }),
)(FeedbackModal)
